import {
    Box,
    Skeleton,
} from "@mui/material";

const SkeletonFileItem = () => {
    return (
        <Box
            sx={{
                border: "1px solid #e5e5e5",
                borderRadius: 2,
                p: 2,
                backgroundColor: "card.background",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
                <Skeleton
                    variant="rectangular"
                    width={40}
                    height={40}
                    sx={{ borderRadius: 1 }}
                />

                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Skeleton variant="text" width="60%" height={20} />
                    <Skeleton variant="text" width="30%" height={16} />
                </Box>

                <Skeleton
                    variant="rectangular"
                    width={80}
                    height={24}
                    sx={{ borderRadius: 1 }}
                />
            </Box>

            <Skeleton
                variant="circular"
                width={32}
                height={32}
            />
        </Box>
    );
};

export default SkeletonFileItem;
